<script>
    import InvalidReasonsType from './InvalidReasonsType.svelte';
    export let row = {};
    export let rowClass = null;
    let componentClass = row.invalid ? 'invalid_element' : 'valid_element';
</script>


<div class={componentClass}>
    {#if row.invalid && componentClass === 'invalid_element'}
        {#if row.invalid_reasons}
            <InvalidReasonsType
                {row}
                showIcon = true
            />
        {/if}
    {/if}
</div>